<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>市场管理</el-breadcrumb-item>
                    <el-breadcrumb-item>投放渠道分析</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox" v-loading="loading">
                <el-tabs type="border-card" style="width: 100%;">
                    <el-tab-pane label="本日">
                        <el-form :inline="true" :model="searchform" style="margin-left:16px" @submit.native.prevent >
                            <el-form-item label="平台">
                                    <el-input v-model="searchform.platform"></el-input>
                                </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit1">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                        <div class="listright">
                            <el-table :data="list" height="800" :span-method="objectSpanMethod" border
                                :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                <el-table-column prop="appName" label="app"></el-table-column>
                                <el-table-column prop="installSize" label="安装数"></el-table-column>
                                <el-table-column prop="channel" label="渠道"></el-table-column>
                                <el-table-column prop="registerNum" label="注册数"></el-table-column>
                                <el-table-column prop="appNum" label="申请数"></el-table-column>
                                <el-table-column prop="appSucNum" label="申请通过数"></el-table-column>
                                <el-table-column prop="loansNum" label="放款成功笔数"></el-table-column>
                                <el-table-column prop="registerAnReat" label="注册-申请率"></el-table-column>
                                <el-table-column prop="registerAppReat" label="申请-申请通过率"></el-table-column>
                                <el-table-column prop="AppSucReat" label="申请通过-放款成功率"></el-table-column>
                                <el-table-column prop="firstRepayment" label="首贷-还款率"></el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="本周">
                        <el-form :inline="true" :model="searchform" style="margin-left:16px" @submit.native.prevent >
                            <el-form-item label="平台">
                                    <el-input v-model="searchform.platform"></el-input>
                                </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit2">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                        <div class="listright">
                            <el-table :data="list1" height="800" :span-method="objectSpanMethod" border
                                :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                <el-table-column prop="appName" label="app"></el-table-column>
                                <el-table-column prop="installSize" label="安装数"></el-table-column>
                                <el-table-column prop="channel" label="渠道"></el-table-column>
                                <el-table-column prop="registerNum" label="注册数"></el-table-column>
                                <el-table-column prop="appNum" label="申请数"></el-table-column>
                                <el-table-column prop="appSucNum" label="申请通过数"></el-table-column>
                                <el-table-column prop="loansNum" label="放款成功笔数"></el-table-column>
                                <el-table-column prop="registerAnReat" label="注册-申请率"></el-table-column>
                                <el-table-column prop="registerAppReat" label="申请-申请通过率"></el-table-column>
                                <el-table-column prop="AppSucReat" label="申请通过-放款成功率"></el-table-column>
                                <el-table-column prop="firstRepayment" label="首贷-还款率"></el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="本月">
                        <el-form :inline="true" :model="searchform" style="margin-left:16px" @submit.native.prevent >
                            <el-form-item label="平台">
                                    <el-input v-model="searchform.platform"></el-input>
                                </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit3">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                        <div class="listright">
                            <el-table :data="list2" height="800" :span-method="objectSpanMethod" border
                                :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                <el-table-column prop="appName" label="app"></el-table-column>
                                <el-table-column prop="installSize" label="安装数"></el-table-column>
                                <el-table-column prop="channel" label="渠道"></el-table-column>
                                <el-table-column prop="registerNum" label="注册数"></el-table-column>
                                <el-table-column prop="appNum" label="申请数"></el-table-column>
                                <el-table-column prop="appSucNum" label="申请通过数"></el-table-column>
                                <el-table-column prop="loansNum" label="放款成功笔数"></el-table-column>
                                <el-table-column prop="registerAnReat" label="注册-申请率"></el-table-column>
                                <el-table-column prop="registerAppReat" label="申请-申请通过率"></el-table-column>
                                <el-table-column prop="AppSucReat" label="申请通过-放款成功率"></el-table-column>
                                <el-table-column prop="firstRepayment" label="首贷-还款率"></el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="自定义时间">
                        <el-form :inline="true" :model="searchform" style="margin-left:16px" @submit.native.prevent >
                            <el-form-item :label="$t('time')">
                                <el-date-picker
                                    v-model="value1"
                                    type="datetimerange"
                                    size="small"
                                    @change="checkdata"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="平台">
                                    <el-input v-model="searchform.platform"></el-input>
                                </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit4">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                        <div class="listright">
                            <el-table :data="list3" height="800" :span-method="objectSpanMethod" border
                                :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                <el-table-column prop="appName" label="app"></el-table-column>
                                <el-table-column prop="installSize" label="安装数"></el-table-column>
                                <el-table-column prop="channel" label="渠道"></el-table-column>
                                <el-table-column prop="registerNum" label="注册数"></el-table-column>
                                <el-table-column prop="appNum" label="申请数"></el-table-column>
                                <el-table-column prop="appSucNum" label="申请通过数"></el-table-column>
                                <el-table-column prop="loansNum" label="放款成功笔数"></el-table-column>
                                <el-table-column prop="registerAnReat" label="注册-申请率"></el-table-column>
                                <el-table-column prop="registerAppReat" label="申请-申请通过率"></el-table-column>
                                <el-table-column prop="AppSucReat" label="申请通过-放款成功率"></el-table-column>
                                <el-table-column prop="firstRepayment" label="首贷-还款率"></el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                searchform: {
                    platform: "",
                },
                loading: false,
                list: [],
                list1: [],
                list2: [],
                list3: [],
                value1: null,
            }
        },
        created() {
            this.getList()
            this.getList1()
            this.getList2()
        },
        methods: {
            getList() {
                this.loading = true
                _api.get(apiurl.channelAn, {
                    type:1,
                    nation:localStorage.getItem("nation"),
                    platform:this.searchform.platform,
                }).then(res => {
                    this.loading = false
                    this.list = res.data
                })
            },
            getList1() {
                this.loading = true
                _api.get(apiurl.channelAn, {
                    type:2,
                    nation:localStorage.getItem("nation"),
                    platform:this.searchform.platform,
                }).then(res => {
                    this.loading = false
                    this.list1 = res.data
                })
            },
            getList2() {
                this.loading = true
                _api.get(apiurl.channelAn, {
                    type:3,
                    nation:localStorage.getItem("nation"),
                    platform:this.searchform.platform,
                }).then(res => {
                    this.loading = false
                    this.list2 = res.data
                })
            },

            getList3() {
                this.loading = true
                _api.get(apiurl.channelAn, {
                    type:4,
                    nation:localStorage.getItem("nation"),
                    platform:this.searchform.platform,
                    time: this.value1
                }).then(res => {
                    this.loading = false
                    this.list3 = res.data
                })
            },

            onSubmit1() {
                this.getList()
            },
            onSubmit2() {
                this.getList1()
            },
            onSubmit3() {
                this.getList2()
            },
            onSubmit4() {
                this.getList3()
            },

            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (columnIndex === 0) {
                    if (rowIndex % 1 === 0) {
                        return {
                            rowspan: 1,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>